import React from 'react';

const TESTIMONIALS = [
  {
    quote: 'What stands out to me most is that Lifelog was created by a caregiver, for caregivers. That perspective comes through in the thoughtfulness of the platform and in its understanding of what daily life really looks like for families like ours.',
    name: 'Heather Burke',
    role: 'Founder, Finding YALL',
  },
  {
    quote: 'As our organization has begun using the platform, we have already seen how it helps bridge the communication gap between caregivers, direct support staff, and families by creating a shared, centralized record of important information.',
    name: 'Letetia Smith, RN',
    role: 'Founder & Executive Director, Take a Step',
  },
];

const LandingTestimonials = () => (
  <section
    className="care-landing-section care-landing-container"
    aria-labelledby="landing-testimonials-title"
  >
    <div className="care-landing-section-heading">
      <span className="care-landing-eyebrow">Community voices</span>
      <h2 id="landing-testimonials-title">Words from people who support families.</h2>
      <p>Excerpts from letters of support for Lifelog.</p>
    </div>
    <div className="care-landing-testimonials">
      {TESTIMONIALS.map(({ quote, name, role }) => (
        <figure className="care-landing-card care-landing-testimonial" key={name}>
          <blockquote><p>“{quote}”</p></blockquote>
          <figcaption>
            <strong>{name}</strong>
            <span>{role}</span>
          </figcaption>
        </figure>
      ))}
    </div>
  </section>
);

export default LandingTestimonials;
